<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    :clear-on-destroy="!isEdit"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <PTOProjectTitle v-if="isEdit" is-edit />

    <VInput
      label="Заявка"
      class="form__input--col-2"
      name="text"
      type="textarea"
    />
  </FormPto>
</template>

<script>
import FormPto from '@/components/pto/form/FormPto'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import Validation from '@/components/page/Form/Validation.vue'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'

export default {
  name: 'FormPtoProjectPtoSupplyRequest',
  components: {
    FormPto,
    PTOProjectTitle,
    // eslint-disable-next-line vue/no-unused-components
    Validation,
    VInput
  },

  mixins: [MIXIN_FORM_PTO]
}
</script>
